import { getJson } from '../../../../shared/api/httpClient';
import config from '../../../../configs/config';

export function requestPasswordReset(email) {
  return getJson('UserResetPwdMarival', { Type: 1, Email: email, Brand: config.emailBrand }, {
    errorMessage: 'Forgot password request failed'
  });
}
